var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho
var l_times = 0;
var r_times = 0;

  $('#right-upc input, #left-upc input').val(val_upc);
	
$('#left-graduacion').click(function() {
    var_l_sph = $('#4079199649870_option_4').val();
	console.log(var_l_sph); 
	unify_values_l();
	fetch_sku_l();
});


$('#right-graduacion').click(function() {
    var_r_sph = $('#4079199649870_option_5').val();
	console.log(var_r_sph); 
	unify_values_r();
	fetch_sku_r();
});


function unify_values_l(){
	sku_values_l = var_l_sph ;
	console.log(sku_values_l);
}

function unify_values_r(){
	sku_values_r = var_r_sph;
	console.log(sku_values_r);
}

function check_times(){
  // 2 = Inmediata, 3 = Exportación, 4 = sin stock
  setTimeout(function(){
    if (l_times == 2){$('.lens-add-btn, .alertLens').show(); $('#left-stock').hide();} 
    if (l_times == 3){$('.lens-add-btn, .alertLens').show(); $('#left-stock').hide();} 
    if (r_times == 2){$('.lens-add-btn, .alertLens').show(); $('#right-stock').hide();} 
    if (r_times == 3){$('.lens-add-btn, .alertLens').show(); $('#right-stock').hide();} 
    if (l_times == 4){$('#left-stock').show(); $('.lens-add-btn, .alertLens').hide();} 
    if (r_times == 4){$('#right-stock').show(); $('.lens-add-btn, .alertLens').hide();} 
  },300);
}

function fetch_sku_l(){
 	switch (sku_values_l) { 
//Sin stock
case '+7.50' : $('#left-sku input').val('98067'); l_times = 4; check_times(); break;

//Con stock
case '-12.00' : $('#left-sku input').val('301432'); l_times = 2; check_times(); break;
case '-11.50' : $('#left-sku input').val('301433'); l_times = 2; check_times(); break;
case '-11.00' : $('#left-sku input').val('301434'); l_times = 2; check_times(); break;
case '-10.50' : $('#left-sku input').val('301435'); l_times = 2; check_times(); break;
case '-10.00' : $('#left-sku input').val('301436'); l_times = 2; check_times(); break;
case '-9.50' : $('#left-sku input').val('301437'); l_times = 2; check_times(); break;
case '-9.00' : $('#left-sku input').val('301438'); l_times = 2; check_times(); break;
case '-8.50' : $('#left-sku input').val('301439'); l_times = 2; check_times(); break;
case '-8.00' : $('#left-sku input').val('301440'); l_times = 2; check_times(); break;
case '-7.50' : $('#left-sku input').val('301441'); l_times = 2; check_times(); break;
case '-7.00' : $('#left-sku input').val('301442'); l_times = 2; check_times(); break;
case '-6.50' : $('#left-sku input').val('301443'); l_times = 2; check_times(); break;
case '-6.00' : $('#left-sku input').val('301444'); l_times = 2; check_times(); break;
case '-5.75' : $('#left-sku input').val('301445'); l_times = 2; check_times(); break;
case '-5.50' : $('#left-sku input').val('301446'); l_times = 2; check_times(); break;
case '-5.25' : $('#left-sku input').val('301447'); l_times = 2; check_times(); break;
case '-5.00' : $('#left-sku input').val('301448'); l_times = 2; check_times(); break;
case '-4.75' : $('#left-sku input').val('301449'); l_times = 2; check_times(); break;
case '-4.50' : $('#left-sku input').val('301450'); l_times = 2; check_times(); break;
case '-4.25' : $('#left-sku input').val('301451'); l_times = 2; check_times(); break;
case '-4.00' : $('#left-sku input').val('301452'); l_times = 2; check_times(); break;
case '-3.75' : $('#left-sku input').val('301453'); l_times = 2; check_times(); break;
case '-3.50' : $('#left-sku input').val('301454'); l_times = 2; check_times(); break;
case '-3.25' : $('#left-sku input').val('301455'); l_times = 2; check_times(); break;
case '-3.00' : $('#left-sku input').val('301456'); l_times = 2; check_times(); break;
case '-2.75' : $('#left-sku input').val('301457'); l_times = 2; check_times(); break;
case '-2.50' : $('#left-sku input').val('301458'); l_times = 2; check_times(); break;
case '-2.25' : $('#left-sku input').val('301459'); l_times = 2; check_times(); break;
case '-2.00' : $('#left-sku input').val('301460'); l_times = 2; check_times(); break;
case '-1.75' : $('#left-sku input').val('301462'); l_times = 2; check_times(); break;
case '-1.50' : $('#left-sku input').val('301461'); l_times = 2; check_times(); break;
case '-1.25' : $('#left-sku input').val('301463'); l_times = 2; check_times(); break;
case '-1.00' : $('#left-sku input').val('301464'); l_times = 2; check_times(); break;
case '-0.75' : $('#left-sku input').val('301465'); l_times = 2; check_times(); break;
case '-0.50' : $('#left-sku input').val('301466'); l_times = 2; check_times(); break;
case '+0.00' : $('#left-sku input').val('301467'); l_times = 2; check_times(); break;
case '+0.50' : $('#left-sku input').val('301468'); l_times = 2; check_times(); break;
case '+0.75' : $('#left-sku input').val('301469'); l_times = 2; check_times(); break;
case '+1.00' : $('#left-sku input').val('301470'); l_times = 2; check_times(); break;
case '+1.25' : $('#left-sku input').val('301471'); l_times = 2; check_times(); break;
case '+1.50' : $('#left-sku input').val('301472'); l_times = 2; check_times(); break;
case '+1.75' : $('#left-sku input').val('301473'); l_times = 2; check_times(); break;
case '+2.00' : $('#left-sku input').val('301474'); l_times = 2; check_times(); break;
case '+2.25' : $('#left-sku input').val('301475'); l_times = 2; check_times(); break;
case '+2.50' : $('#left-sku input').val('301476'); l_times = 2; check_times(); break;
case '+2.75' : $('#left-sku input').val('301477'); l_times = 2; check_times(); break;
case '+3.00' : $('#left-sku input').val('301478'); l_times = 2; check_times(); break;
case '+3.25' : $('#left-sku input').val('301479'); l_times = 2; check_times(); break;
case '+3.50' : $('#left-sku input').val('301480'); l_times = 2; check_times(); break;
case '+3.75' : $('#left-sku input').val('301481'); l_times = 2; check_times(); break;
case '+4.00' : $('#left-sku input').val('301482'); l_times = 2; check_times(); break;
case '+4.25' : $('#left-sku input').val('301483'); l_times = 2; check_times(); break;
case '+4.50' : $('#left-sku input').val('301484'); l_times = 2; check_times(); break;
case '+4.75' : $('#left-sku input').val('301485'); l_times = 2; check_times(); break;
case '+5.00' : $('#left-sku input').val('301486'); l_times = 2; check_times(); break;
case '+5.25' : $('#left-sku input').val('301487'); l_times = 2; check_times(); break;
case '+5.50' : $('#left-sku input').val('301488'); l_times = 2; check_times(); break;
case '+5.75' : $('#left-sku input').val('301489'); l_times = 2; check_times(); break;
case '+6.00' : $('#left-sku input').val('301490'); l_times = 2; check_times(); break;
case '+6.50' : $('#left-sku input').val('301491'); l_times = 2; check_times(); break;
case '+7.00' : $('#left-sku input').val('301492'); l_times = 2; check_times(); break;
case '+7.50' : $('#left-sku input').val('301493'); l_times = 2; check_times(); break;
case '+8.00' : $('#left-sku input').val('301494'); l_times = 2; check_times(); break;
case 'null' : l_times = 4 ; check_times(); break;
default: $('#right-sku input').val('SKU Desconocido'); l_times = 4; check_times(); break; 
    }
}//fetch_sku()

function fetch_sku_r(){
 	switch (sku_values_r) {
//Sin stock
case '+7.50' : $('#right-sku input').val('98067'); r_times = 4; check_times(); break;

//Con stock
case '-12.00' : $('#right-sku input').val('301432'); r_times = 2; check_times(); break;
case '-11.50' : $('#right-sku input').val('301433'); r_times = 2; check_times(); break;
case '-11.00' : $('#right-sku input').val('301434'); r_times = 2; check_times(); break;
case '-10.50' : $('#right-sku input').val('301435'); r_times = 2; check_times(); break;
case '-10.00' : $('#right-sku input').val('301436'); r_times = 2; check_times(); break;
case '-9.50' : $('#right-sku input').val('301437'); r_times = 2; check_times(); break;
case '-9.00' : $('#right-sku input').val('301438'); r_times = 2; check_times(); break;
case '-8.50' : $('#right-sku input').val('301439'); r_times = 2; check_times(); break;
case '-8.00' : $('#right-sku input').val('301440'); r_times = 2; check_times(); break;
case '-7.50' : $('#right-sku input').val('301441'); r_times = 2; check_times(); break;
case '-7.00' : $('#right-sku input').val('301442'); r_times = 2; check_times(); break;
case '-6.50' : $('#right-sku input').val('301443'); r_times = 2; check_times(); break;
case '-6.00' : $('#right-sku input').val('301444'); r_times = 2; check_times(); break;
case '-5.75' : $('#right-sku input').val('301445'); r_times = 2; check_times(); break;
case '-5.50' : $('#right-sku input').val('301446'); r_times = 2; check_times(); break;
case '-5.25' : $('#right-sku input').val('301447'); r_times = 2; check_times(); break;
case '-5.00' : $('#right-sku input').val('301448'); r_times = 2; check_times(); break;
case '-4.75' : $('#right-sku input').val('301449'); r_times = 2; check_times(); break;
case '-4.50' : $('#right-sku input').val('301450'); r_times = 2; check_times(); break;
case '-4.25' : $('#right-sku input').val('301451'); r_times = 2; check_times(); break;
case '-4.00' : $('#right-sku input').val('301452'); r_times = 2; check_times(); break;
case '-3.75' : $('#right-sku input').val('301453'); r_times = 2; check_times(); break;
case '-3.50' : $('#right-sku input').val('301454'); r_times = 2; check_times(); break;
case '-3.25' : $('#right-sku input').val('301455'); r_times = 2; check_times(); break;
case '-3.00' : $('#right-sku input').val('301456'); r_times = 2; check_times(); break;
case '-2.75' : $('#right-sku input').val('301457'); r_times = 2; check_times(); break;
case '-2.50' : $('#right-sku input').val('301458'); r_times = 2; check_times(); break;
case '-2.25' : $('#right-sku input').val('301459'); r_times = 2; check_times(); break;
case '-2.00' : $('#right-sku input').val('301460'); r_times = 2; check_times(); break;
case '-1.75' : $('#right-sku input').val('301462'); r_times = 2; check_times(); break;
case '-1.50' : $('#right-sku input').val('301461'); r_times = 2; check_times(); break;
case '-1.25' : $('#right-sku input').val('301463'); r_times = 2; check_times(); break;
case '-1.00' : $('#right-sku input').val('301464'); r_times = 2; check_times(); break;
case '-0.75' : $('#right-sku input').val('301465'); r_times = 2; check_times(); break;
case '-0.50' : $('#right-sku input').val('301466'); r_times = 2; check_times(); break;
case '+0.00' : $('#right-sku input').val('301467'); r_times = 2; check_times(); break;
case '+0.50' : $('#right-sku input').val('301468'); r_times = 2; check_times(); break;
case '+0.75' : $('#right-sku input').val('301469'); r_times = 2; check_times(); break;
case '+1.00' : $('#right-sku input').val('301470'); r_times = 2; check_times(); break;
case '+1.25' : $('#right-sku input').val('301471'); r_times = 2; check_times(); break;
case '+1.50' : $('#right-sku input').val('301472'); r_times = 2; check_times(); break;
case '+1.75' : $('#right-sku input').val('301473'); r_times = 2; check_times(); break;
case '+2.00' : $('#right-sku input').val('301474'); r_times = 2; check_times(); break;
case '+2.25' : $('#right-sku input').val('301475'); r_times = 2; check_times(); break;
case '+2.50' : $('#right-sku input').val('301476'); r_times = 2; check_times(); break;
case '+2.75' : $('#right-sku input').val('301477'); r_times = 2; check_times(); break;
case '+3.00' : $('#right-sku input').val('301478'); r_times = 2; check_times(); break;
case '+3.25' : $('#right-sku input').val('301479'); r_times = 2; check_times(); break;
case '+3.50' : $('#right-sku input').val('301480'); r_times = 2; check_times(); break;
case '+3.75' : $('#right-sku input').val('301481'); r_times = 2; check_times(); break;
case '+4.00' : $('#right-sku input').val('301482'); r_times = 2; check_times(); break;
case '+4.25' : $('#right-sku input').val('301483'); r_times = 2; check_times(); break;
case '+4.50' : $('#right-sku input').val('301484'); r_times = 2; check_times(); break;
case '+4.75' : $('#right-sku input').val('301485'); r_times = 2; check_times(); break;
case '+5.00' : $('#right-sku input').val('301486'); r_times = 2; check_times(); break;
case '+5.25' : $('#right-sku input').val('301487'); r_times = 2; check_times(); break;
case '+5.50' : $('#right-sku input').val('301488'); r_times = 2; check_times(); break;
case '+5.75' : $('#right-sku input').val('301489'); r_times = 2; check_times(); break;
case '+6.00' : $('#right-sku input').val('301490'); r_times = 2; check_times(); break;
case '+6.50' : $('#right-sku input').val('301491'); r_times = 2; check_times(); break;
case '+7.00' : $('#right-sku input').val('301492'); r_times = 2; check_times(); break;
case '+7.50' : $('#right-sku input').val('301493'); r_times = 2; check_times(); break;
case '+8.00' : $('#right-sku input').val('301494'); r_times = 2; check_times(); break;
case 'null' : r_times = 4 ; check_times(); break;
default: $('#right-sku input').val('SKU Desconocido'); r_times = 4; check_times(); break; 

    }
}//fetch_sku()


